import * as rx from 'rxjs'
import { tap, retry, flatMap } from 'rxjs/operators'
import { isNil } from 'ramda'

const createRefreshTokenObservable = (performRefreshToken) => (token) =>
  rx.of(token).pipe(
    flatMap((token) => rx.from(performRefreshToken(token))),
    retry(2),
  )

export function refreshTokenObservable({
  getToken,
  getMaKey,
  updateAccessToken,
  removeToken,
  performRefreshToken,
  getDate,
}) {
  const token = getToken()
  const maModeKey = getMaKey()
  if (isNil(token)) return new rx.throwError('Unauthorized, No token stored')
  if (token.expiresAt > getDate()) return rx.of({ ...token, maModeKey })
  return createRefreshTokenObservable(performRefreshToken)().pipe(
    tap({
      next: (response) => {
        updateAccessToken({
          accessToken: response.accessToken,
          maModeKey,
          expiresIn: response.expiresIn,
          expiresAt: response.expiresAt,
        })
      },
      error: removeToken,
    }),
  )
}
